import React from 'react';
import { Box, Typography } from '@mui/material';

// คู่ label/value แบบมาตรฐานเดียวกันทุกจุดที่โชว์ข้อมูล opportunity (ข้อมูลทั่วไป,
// ผลการปิดงาน ฯลฯ) — label ใช้ overline เล็ก ๆ สีจาง value ใช้ตัวหนังสือปกติเข้มกว่า
export function FieldDisplay({ label, value, emphasis, align }) {
  return (
    <Box sx={{ textAlign: align }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', textTransform: 'uppercase', letterSpacing: 0.4, fontSize: '0.7rem', mb: 0.25 }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: emphasis ? 700 : 500,
          color: emphasis ? 'text.primary' : 'text.primary',
          whiteSpace: 'pre-line',
        }}
      >
        {value ?? '-'}
      </Typography>
    </Box>
  );
}

export default FieldDisplay;
